import React from 'react';

/** Premium iPhone frame wrapping a real app screenshot. */
export function PhoneFrame({ children, glowIntensity = 'md', tilt = 0, className = '' }) {
  const glowMap = {
    sm: '0 25px 60px -15px rgba(168,58,74,0.30), 0 0 80px -10px rgba(168,58,74,0.15)',
    md: '0 35px 90px -20px rgba(168,58,74,0.50), 0 0 120px -10px rgba(168,58,74,0.25)',
    lg: '0 45px 120px -20px rgba(168,58,74,0.65), 0 0 160px -10px rgba(168,58,74,0.35)',
  };
  return (
    <div
      className={`relative mx-auto w-[280px] sm:w-[300px] ${className}`}
      style={{ transform: tilt ? `rotate(${tilt}deg)` : undefined, transition: 'transform 0.6s ease' }}
    >
      <div
        className="relative aspect-[9/19.5] rounded-[2.5rem] p-[3px]"
        style={{
          background: 'linear-gradient(160deg, #2a2a2a 0%, #050505 35%, #1a1a1a 65%, #050505 100%)',
          boxShadow: glowMap[glowIntensity],
        }}
      >
        <div className="relative h-full w-full rounded-[2.3rem] bg-black p-[6px]">
          {/* Notch */}
          <div className="absolute top-[10px] left-1/2 -translate-x-1/2 w-24 h-6 bg-black rounded-b-[1.2rem] z-30 flex items-center justify-center gap-2">
            <div className="w-1.5 h-1.5 rounded-full bg-[#1a1a1a]" />
            <div className="w-2 h-2 rounded-full bg-[#0a0a0a]" />
          </div>
          {/* Screen surface */}
          <div className="relative w-full h-full rounded-[1.9rem] overflow-hidden bg-[#030303]">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}

/** Render a real app screenshot inside the screen surface. */
export function RealScreen({ src, alt }) {
  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      decoding="async"
      className="absolute inset-0 w-full h-full object-cover object-top"
      draggable={false}
    />
  );
}
